import { render, staticRenderFns } from "./PublicCGV.vue?vue&type=template&id=74496e89&"
import script from "./PublicCGV.vue?vue&type=script&lang=js&"
export * from "./PublicCGV.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports